module.exports = __webpack_public_path__ + "media/homepage/quote-a5018f83.webp";